import { Grid } from "@mui/material";
import { animated, useSpring } from "@react-spring/web";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import BroadcastModal from "../../components/BroadcastModal/BroadcastModal";
import Loader from "../../components/CustomLoader";
import DeleteModal from "../../components/DeleteModal";
import SaveChangesModal from "../../components/SaveChangesModal";
import SegmentSetting from "../../components/SegmentBuilder/Main/SegmentSetting";
import Sidepane from "../../components/SegmentBuilder/Main/Sidepane";
import WheelLayout from "../../components/SegmentBuilder/Main/WheelLayout";
import SegmentView from "../../components/SegmentView";
import WheelComponent from "../../components/WheelComponent";
import { initialSegmentNode, newSegment } from "../../constants/wheelData";
import useSegmentSettings from "../../hooks/useSegmentSetting";
import { getUserBgWallpapersAction } from "../../redux/actions/wallpapers";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import {
  resetToWheelBgToInitialState,
  updateWallpaperInitialState,
} from "../../redux/actions/wheelWallpaper";
import {
  addWheelData,
  handleCloseMenu,
  handleMenuChange,
  pushToHistoryAction,
  resetBuilder,
  setBusinessBoxWheel,
  setDesignTabTarget,
  setIsDraft,
  setIsSavingWheel,
  setSelectedSegmentCharCount,
  setWheelId,
  setWheelRotateBoxVisibility,
  setWheelSegments,
  updateSegmentSuggestedColors,
  markChangesSaved,
  setTakeScreenshot,
  setWheelPreview,
} from "../../redux/reducers/segmentBuilder";
import {
  getHasUnsavedChanges,
  getRotateBoxVisibility,
  getSelectedMenu,
  getSelectedSegment,
  getSelectedSegmentCharCount,
  getWheelAuthorId,
  getWheelAutoResizing,
  getWheelBusinessBox,
  getWheelId,
  getWheelIsDraftValue,
  getWheelIsLiveValue,
  getWheelSegments,
} from "../../redux/selectors/segmentBuilderSelectors";
import { getWheelDetails, updateWheelPreview } from "../../services/api";
import {
  useBroadcastChanges,
  useCreateWheelV2,
  useGetSuggestedColorPalette,
  useUpdateWheelV2,
} from "../../services/mutations";
import {
  convertSnakeToCamel,
  extractItemsFromSegments,
  fetchImageAsBase64,
  getHexColors,
  getLoggedInUser,
} from "../../utils/helpers";
import Editor from "./Editor";
import RightSection from "./RightSection";
import SegmentActions from "./SegmentActions";
import * as Styled from "./style";
import "./styles.css";
import WaitlistFormModal from "../../components/WaitlistModal";
import { setWheelSettingsTab } from "../../redux/reducers/wheelSettings";
import { ASSETS } from "../../utils/config";
import UpdateLiveClones from "../../components/BroadcastModal/UpdateLiveClones";
import { setColorPaletteDefault } from "../../redux/reducers/colorPalette";
import BusinessBoxBuilder from "../../components/SegmentBuilder/Main/BusinessBoxBuilder";
import GallerySettings from "../../components/WheelGallery/GallerySettings";
import { isEmpty, isEqual } from "lodash";
import { revertGlobalSettingsFromApiFormat } from "../../utils/segmentBuilderUtils";
import HotbarBuilder from "../../components/SegmentBuilder/Main/HotbarBuilder";
import { setSegmentItems } from "../../redux/reducers/newhotbar";
import PreviewCarousel from "../../components/NewHotbar/PreviewCarousel";
import ConfirmationModal from "../../components/SegmentBuilder/Main/BusinessBoxBuilder/children/ConfirmationModal";
import { redistributeProportionally } from "../../components/SegmentBuilder/Main/SegmentsTab";
import { countAllNodes } from "../../components/SegmentBuilder/Main/SegmentsTab/SegmentsTabHelpers";
import { useMutation } from "react-query";
import axios from "axios";
import { extractMediaUrlsOnly } from "../../utils/segmentUtils";
import { sendWheelMedia } from "../../services/api";
import MoveBlockModal from "../../components/SegmentBuilder/Shared/MoveBlockModal";
import { useScreenshot } from "use-react-screenshot";
import ScreenshotModal from "../ViewWheel/ScreenshotModal";
import { getWheelUploadPath, handleFileUpload } from "../../utils/fileUpload";
import DefaultIyugaLogo from "@assets/images/iyuga.jpg";
import { closeModal } from "../../redux/reducers/dialog";
import { countTextCharacters } from "../../components/SegmentBuilder/Main/SegmentsTab/SegmentsTabHelpers";
import { charLimitInASegment } from "../../components/SegmentSettings";
import SegmentLibrary from "../../components/SegmentBuilder/Main/SegmentLibrary";
import { useSegmentPalettes } from "../../hooks/useSegmentPalettes";

export default function SegmentBuilder() {
  const selectedMenu = useSelector(getSelectedMenu);
  const [isSideMenuActive, setIsSideMenuActive] = useState(false);
  const [showLabels, setShowLabels] = useState(true);
  const [editorState, setEditorState] = useState("");
  const [loading, setLoading] = useState(false);
  const [isEmptyWheel, setIsEmptyWheel] = useState(false);
  const [isDirty, setIsDirty] = useState(false); // Track unsaved changes
  const [waitListModalVisible, setWaitListModalVisible] = useState(false);
  const selectedArc = useSelector(getSelectedSegment);
  const hasUnsavedChanges = useSelector(getHasUnsavedChanges);

  const createWheel = useCreateWheelV2();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const wheelIdInRedux = useSelector(getWheelId);
  const updateWheel = useUpdateWheelV2(wheelIdInRedux ?? id);
  const rotateBoxVisibility = useSelector(getRotateBoxVisibility);

  const [modalOpen, setModalOpen] = useState(false);
  const [onLeave, setOnLeave] = useState(() => {});

  const [gallerySettingsOpen, setGallerySettingsOpen] = useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const [showUpdateCloneModal, setshowUpdateCloneModal] = useState(false);

  const bboxData = useSelector(getWheelBusinessBox);

  const galleryBusinessBox = useSelector(
    (state) => state.userProfile?.userProfile?.business_box
  );
  const automaticResizing = useSelector(getWheelAutoResizing);
  const [overLimitWarningShown, setOverLimitWarningShown] = useState(false);
  const prevTotalRef = useRef(0);

  const selectedSegmentCharCount = useSelector(getSelectedSegmentCharCount);

  const { fetchSegmentPalette } = useSegmentPalettes();

  const {
    selectedType,
    selectedItem,
    isPreviewOpen,
    selectedSegment,
    segments,
  } = useSelector((state) => state?.hotbar);

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  function sortSegmentsByPosition(segments) {
    return segments.sort((a, b) => a.position - b.position);
  }

  // Ref to track if we've shown the toast for this segment
  const hasShownLimitToastRef = useRef(false);

  // useEffect(() => {
  //   if (
  //     selectedSegmentCharCount >= charLimitInASegment &&
  //     !hasShownLimitToastRef.current
  //   ) {
  //     toast.error("Segment text limit has been reached.");
  //     hasShownLimitToastRef.current = true;
  //   } else if (selectedSegmentCharCount < charLimitInASegment) {
  //     // Reset the flag when count goes below the limit again
  //     hasShownLimitToastRef.current = false;
  //   }
  // }, [selectedSegmentCharCount, charLimitInASegment]);

  useEffect(() => {
    dispatch(setColorPaletteDefault({ paletteType: "segment" }));
    if (!selectedArc && selectedMenu == 2) dispatch(handleCloseMenu());
    // Don't auto-switch to SegmentSetting when SegmentLibrary is open
    if (selectedArc && selectedMenu !== 6)
      dispatch(handleMenuChange({ num: 2 }));

    if (!selectedArc?.selected) {
      dispatch(handleCloseMenu());
    }
    return () => {
      dispatch(setColorPaletteDefault({ paletteType: "wheel" }));
    };
  }, [selectedArc?.id]);

  function mergeEmailsPermission(emails, permission) {
    return [...new Set([...emails, ...permission])];
  }

  const navigateToWheel = (id) => {
    navigate(`/wheel/${id}`);
  };

  const getWheelData = async (id) => {
    try {
      // Fetch wheel details
      setLoading(true);
      const wheelDetails = await getWheelDetails(id);
      if (wheelDetails?.data?.data) {
        let response = wheelDetails?.data?.data;

        const status_code = response?.status_code;
        console.log(status_code, "status_code");

        const is_editable = response?.is_editable;
        // const NotMyWheel =
        //   getLoggedInUser()?.id !== response?.wheel_author?.user_id;
        // const isWheelCloned = response?.is_editable;
        // const isWheelLive = response?.is_live;
        // const isWheelLocked = response?.is_locked;
        const globalSettings = response?.global_settings;
        if (!is_editable) {
          navigateToWheel(id);
          return;
        }

        const modifiedSegmentData = response.wheel_segments.map((s) => {
          const { nodes, position, ...rest } = s;
          const { activity, category, ...settingsRest } = s.settings;

          const parsedNodes =
            typeof nodes == "string" ? JSON.parse(nodes) : nodes;

          return {
            ...rest,
            selected: position == selectedArc?.position ? true : false,
            position,
            category: 1, // This will replace with actual category id
            settings: convertSnakeToCamel(settingsRest),
            nodes: parsedNodes,
            is_modified: false,
            initialNode: parsedNodes, // Store the initial node state
          };
        });

        dispatch(
          updateWallpaperInitialState(
            convertSnakeToCamel(response.wallpaper_settings)
          )
        );
        dispatch(
          addWheelData({
            ...response,
            globalSettings: revertGlobalSettingsFromApiFormat(globalSettings),
            wheel_segments: sortSegmentsByPosition(modifiedSegmentData),
          })
        );
        dispatch(handleMenuChange({ num: selectedMenu }));
        if (!isEmpty(response.business_box)) {
          dispatch(setBusinessBoxWheel(response.business_box));
        }
        if (isEmpty(response.business_box) && !isEmpty(galleryBusinessBox)) {
          dispatch(setBusinessBoxWheel(galleryBusinessBox));
        }
        // const newHeights = {};
        // modifiedSegmentData.forEach((seg) => {
        //   newHeights[seg.settings.id] = seg.content_height;
        // });
        // dispatch(setContentHeights(newHeights));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.message);
      if (error.response.data.status_code == 400) {
        navigateToWheel(id);
        return;
      }
    }
  };

  useEffect(() => {
    if (id) getWheelData(id);
  }, [id]);

  const wheelData = useSelector(getWheelSegments);
  const authorId = useSelector(getWheelAuthorId);
  const dispatch = useDispatch();
  const nav = useNavigate();
  const categoryData = useSelector((state) => state.categoryColors);

  console.log(selectedSegmentCharCount, "yamaW", selectedArc);

  useEffect(() => {
    if (id) {
      const processedSegments = extractItemsFromSegments(wheelData);
      dispatch(setSegmentItems(processedSegments));
    }
  }, [wheelData, id]);

  function arraysAreSame(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item, i) => item.value === arr2[i].value);
  }

  //Validation for the resizing the segments
  useEffect(() => {
    const total = wheelData.reduce((sum, sb) => sum + sb.value, 0);

    if (Math.abs(total - 100) > 0.01) {
      const unlockedSegments = wheelData.filter((sb) => !sb.resize_lock);
      const lockedValue = wheelData.reduce(
        (sum, sb) => sum + (sb.resize_lock ? sb.value : 0),
        0
      );

      const availableValue = 100 - lockedValue;
      const distributedValues = redistributeProportionally(
        availableValue,
        unlockedSegments
      );

      let index = 0;
      const correctedSegments = wheelData.map((sb) => ({
        ...sb,
        value: sb.resize_lock
          ? sb.value
          : Number(distributedValues[index++].toFixed(2)),
      }));

      console.log(correctedSegments, "CORR 1", prevTotalRef.current);

      if (!arraysAreSame(correctedSegments, wheelData)) {
        dispatch(setWheelSegments(correctedSegments));
      }
    }
  }, [wheelData]);

  const {
    wallpaperTransparency,
    wallpaperResizing,
    wallpaperOverlayColor,
    bgWallpaper,
    isPattern,
    segmentBgColor,
    currentBg,
    selectedColorType,
  } = useSelector((state) => state.wheelWallpaperReducer);

  const { mutate } = useGetSuggestedColorPalette({
    onSuccess: (data) => {
      dispatch(
        updateSegmentSuggestedColors({
          id: wheelData?.length + 1,
          suggestedColors: getHexColors(data?.data?.data),
        })
      );
    },
  });

  useEffect(() => {
    if (getLoggedInUser()?.id) {
      dispatch(getUserBgWallpapersAction());
    }
    setTimeout(() => {
      if (id) {
        setIsEmptyWheel(false);
      } else if (wheelData?.length == 0) {
        setIsEmptyWheel(true);
      }
    }, 1000);

    return () => {
      dispatch(resetBuilder());
    };
  }, []);

  useEffect(() => {
    setIsSideMenuActive(!!selectedMenu);
  }, [selectedMenu]);

  const {
    getColor,
    handleChange,
    getMaxPosition,
    handleRotationData,
    generatePayload,
  } = useSegmentSettings() || {};

  const handleCloseSidePane = () => dispatch(handleCloseMenu());

  const [openLibraryInBusinessBox, setOpenLibraryInBusinessBox] =
    useState(false);

  const handleBusinessBoxEditorOpen = (openLibrary = false) => {
    setOpenLibraryInBusinessBox(openLibrary);
    setGallerySettingsOpen(true);
  };

  const handleReplaceBusinessBoxClick = () => {
    handleBusinessBoxEditorOpen(true); // Pass true to open library section
  };

  const handleEditBusinessBoxClick = () => {
    if (
      !isEmpty(galleryBusinessBox) &&
      galleryBusinessBox?.id === bboxData?.id
    ) {
      setConfirmationModalOpen(true);
    } else {
      handleBusinessBoxEditorOpen();
    }
  };

  const componentMap = [
    {
      isVisible: selectedMenu === 1,
      Component: Sidepane,
      props: {
        isVisible: selectedMenu === 1,
        onClose: handleCloseSidePane,
      },
    },
    {
      isVisible: selectedMenu === 2,
      Component: SegmentSetting,
      props: {
        isVisible: selectedMenu === 2,
        onClose: handleCloseSidePane,
      },
    },
    {
      isVisible: selectedMenu === 3,
      Component: RightSection,
      props: {
        segmentSettings: selectedArc?.settings || {},
        handleChange,
        isVisible: selectedMenu === 3,
        onClose: handleCloseSidePane,
      },
    },
    {
      isVisible: selectedMenu === 4,
      Component: HotbarBuilder,
      props: {
        isVisible: selectedMenu === 4,
        onClose: handleCloseSidePane,
      },
    },
    {
      isVisible: selectedMenu === 5,
      Component: BusinessBoxBuilder,
      props: {
        isVisible: selectedMenu === 5,
        onClose: handleCloseSidePane,
        onEditClick: handleEditBusinessBoxClick,
        onReplaceClick: handleReplaceBusinessBoxClick, // Add this
      },
    },
    {
      isVisible: selectedMenu === 6,
      Component: SegmentLibrary,
      props: {
        isVisible: selectedMenu === 6,
        onClose: handleCloseSidePane,
        // onEditClick: handleEditBusinessBoxClick,
        // onReplaceClick: handleReplaceBusinessBoxClick, // Add this
      },
    },
  ];

  const firstDivStyles = useSpring({
    width: !!selectedMenu
      ? selectedMenu === 5
        ? "68vw" // Business Box gets more space on left
        : "64vw"
      : "94vw",
    config: { duration: 500 },
  });

  const secondDivStyles = useSpring({
    width: !!selectedMenu
      ? selectedMenu === 5
        ? "25vw" // Business Box side pane is narrower
        : "30vw"
      : "0vw",
    config: { duration: 500 },
  });

  useEffect(() => {
    if (authorId && getLoggedInUser().id !== authorId) {
      nav(`/wheel/${id}`);
    }
  }, [authorId]);

  const handleSwitch = () => setShowLabels(!showLabels);

  const [lockWarningModalOpen, setLockWarningModalOpen] = useState(false);

  const addSegment = () => {
    //    This prevents adding new segments when all are locked
    //    or if your largest unlocked segment is too small (<= 1).
    const allLocked =
      wheelData.length > 0 && wheelData.every((sb) => sb.resize_lock);
    const unlockedSegments = wheelData.filter((sb) => !sb.resize_lock);
    unlockedSegments.sort((a, b) => b.value - a.value);

    // If everything is locked or the biggest unlocked segment is ≤ 1, show modal
    if (
      allLocked ||
      (unlockedSegments.length === 1 && unlockedSegments[0].value <= 1) ||
      (unlockedSegments.length > 0 && unlockedSegments[0].value <= 1)
    ) {
      setLockWarningModalOpen(true);
      return;
    }

    // Rest of your existing addSegment function
    setIsDirty(true);
    const newWheelData = wheelData.map((d, i) => ({
      ...d,
      position: typeof d.position === "number" ? d.position : (i + 1) * 10,
    }));

    const id = newWheelData.length + 1;

    const { color, colorInner } = getColor(newWheelData, newWheelData.length);

    const lastPosition = getMaxPosition(newWheelData);

    const currIndex = newWheelData.findIndex((e) => e.selected);
    let currentPos = 10;
    if (currIndex !== -1) {
      const nextIndex = currIndex + 1;
      currentPos =
        nextIndex < newWheelData.length
          ? newWheelData[nextIndex].position
          : lastPosition + 10;
    } else if (newWheelData.length > 0) {
      currentPos = lastPosition + 10;
    }

    const updatedWheelData = newWheelData.map((d, i) => ({
      ...d,
      selected: false,
      position: currIndex > -1 && i > currIndex ? d.position + 10 : d.position,
    }));

    // there is no currIndex ( means none of the index has selected true) all of them are false.

    //then the current index should be the last item. newWheelData.lenght

    const adjustedIndex =
      currIndex !== -1 ? currIndex : newWheelData.length - 1;

    if (automaticResizing) {
      // Gather code-block counts for *existing* segments
      let totalNodeCount = 0;
      const existingSegmentsWithCounts = updatedWheelData.map((seg) => {
        const nodeMap =
          typeof seg.nodes === "string" ? JSON.parse(seg.nodes) : seg.nodes;
        const nodeCount = countAllNodes(nodeMap, "ROOT"); // implement countAllNodes as needed
        totalNodeCount += nodeCount;
        return { ...seg, node_count: nodeCount };
      });

      // For our new (empty) segment, define at least 1 node if you want
      const newSegmentNodeCount = 1; // or more if you have default blocks
      totalNodeCount += newSegmentNodeCount;

      // Compute the fraction => new segment's value
      const ratioForNew = newSegmentNodeCount / totalNodeCount;
      const finalValue = Number((ratioForNew * 100).toFixed(2));

      // Now splice the new segment with its computed finalValue
      updatedWheelData.splice(
        adjustedIndex + 1,
        0,
        newSegment({
          id,
          currentPos,
          color,
          colorInner,
          newSegmentValue: finalValue,
        })
      );
    } else {
      // PROPORTIONALLY REDUCE UNLOCKED SEGMENTS BEFORE INSERTING NEW ONE
      //    ---------------------------------------------------------------
      //  e.g., If the biggest unlocked segment is 50% of the total unlocked,
      //  we reduce it by ~50% of whatever space the new segment needs.
      const unlockedSum = unlockedSegments.reduce(
        (sum, sb) => sum + sb.value,
        0
      );

      // Distribute the new segment value so that all unlocked segments
      // share the "loss" of those points.
      const newSegmentValue = Number(
        Math.floor(unlockedSum / (unlockedSegments.length + 1)).toFixed(2)
      );
      if (newSegmentValue < 1 && unlockedSegments.length > 0) return; // Don't allow sub-1 segments

      let finalValue = Math.max(1, newSegmentValue);

      // Everyone loses enough total to "give" newSegmentValue to the new segment
      const valueToReduce = finalValue;
      updatedWheelData.forEach((sb) => {
        if (!sb.resize_lock) {
          const reductionRatio = sb.value / unlockedSum;
          const reduction = Math.floor(valueToReduce * reductionRatio);
          sb.value = Number(Math.max(1, sb.value - reduction).toFixed(2));
        }
      });

      updatedWheelData.splice(
        adjustedIndex + 1,
        0,
        newSegment({
          id,
          currentPos,
          color,
          colorInner,
          newSegmentValue: finalValue,
        })
      );
    }

    let totalData = updatedWheelData.reduce((sum, s) => sum + s.data_value, 0);

    const finalSegments = updatedWheelData.map((seg) => {
      const newDataValue = (seg.value / 100) * totalData;
      return {
        ...seg,
        data_value: Math.max(1, Math.floor(newDataValue)),
      };
    });

    dispatch(pushToHistoryAction()); // Push the new state to history

    fetchSegmentPalette(color, id);
    dispatch(setWheelSegments(finalSegments));
    dispatch(handleMenuChange({ num: 2 }));
    mutate({
      categories: ["main_brand"],
      category_colors: [color],
    });
    setIsEmptyWheel(false);
  };

  useEffect(() => {
    if (selectedArc) {
      const updatedWheelData = wheelData.map((segment) => {
        if (segment.id === selectedArc.id) {
          const initialNodes = segment.initialNode;

          console.log(
            // initialNodes,
            initialNodes,
            "initilNode",
            editorState,
            editorState !== initialNodes,
            initialSegmentNode,
            editorState === initialSegmentNode,
            selectedArc
          );
          // Only mark as modified if the nodes have actually changed from initial state OR if it doesnt have created_at (new segment)
          const isModified =
            !selectedArc?.created_at || editorState !== initialNodes;

          return {
            ...segment,
            is_modified: isModified,
            nodes: editorState,
          };
        }
        return segment;
      });
      dispatch(pushToHistoryAction());
      dispatch(setWheelSegments(updatedWheelData));
    }
  }, [editorState]);

  // Calculate character count when segment is selected
  useEffect(() => {
    if (selectedArc) {
      try {
        const nodeMap =
          typeof selectedArc.nodes === "string"
            ? JSON.parse(selectedArc.nodes)
            : selectedArc.nodes;

        // Calculate the character count and dispatch it to Redux
        const charCount = countTextCharacters(nodeMap, "ROOT");
        dispatch(setSelectedSegmentCharCount(charCount));
      } catch (error) {
        console.error("Error counting text characters:", error);
        dispatch(setSelectedSegmentCharCount(0));
      }
    }
  }, [selectedArc, editorState]);

  const handleSetChartData = (newChartData) => {
    // Create a map of segment IDs from wheelData using settings.id
    const segmentIdMap = {};
    wheelData.forEach((segment) => {
      // Use settings.id as the key to map to the segment's id
      if (segment.settings && segment.settings.id) {
        segmentIdMap[segment.settings.id] = segment.id;
      }
    });

    // Update the data while preserving original IDs by matching settings.id with segment.id
    const updatedData = newChartData.map((segment) => {
      // If this segment's ID exists in our settings.id map, use the corresponding server ID
      const originalId = segmentIdMap[segment.id];

      return {
        ...segment,
        id: originalId || segment.id, // Use original ID if available, otherwise keep the current ID
      };
    });

    console.log(newChartData, "neuv", updatedData);

    dispatch(pushToHistoryAction());
    dispatch(setWheelSegments(updatedData));
  };

  const onSegmentClose = () => {
    const idToRemove = selectedArc.id;
    const updatedChartData = clonedWheelData?.map((data) => {
      if (data?.id === idToRemove) {
        data.selected = false;
      }
      return data;
    });
    dispatch(pushToHistoryAction());

    dispatch(setWheelSegments(updatedChartData));
  };

  const clonedWheelData = wheelData.map((segment) => ({
    ...segment,
    ...segment?.settings,
  }));

  const handleNodesChange = (editorState) => {
    try {
      const json = editorState.serialize();
      setEditorState(json);
    } catch (error) {}
  };

  const handleRotation = (direction = "prev") => {
    if (!wheelData?.length) return;
    dispatch(pushToHistoryAction());
    dispatch(setWheelSegments(handleRotationData(wheelData, direction)));
  };

  const wheelInformation = useSelector((state) => state.segmentBuilder);

  const wheelWallpaperSettings = useSelector(
    (state) => state.wheelWallpaperReducer
  );

  const [isAutoSaving, setIsAutoSaving] = useState(false);
  const [isAutoSaveError, setIsAutoSaveError] = useState(false);
  const [showUnSaved, setShowUnSaved] = useState(false);

  const addIdToUrl = (id) => {
    const newPath = `${location.pathname}/${id}`;
    navigate(newPath, { replace: true });
  };

  const handleMutation = (
    mutationFunc,
    successMessage,
    payload,
    isManualSave = true,
    callback = () => {}
  ) => {
    dispatch(setIsSavingWheel(true));
    setIsAutoSaving(true);
    console.log({ payload });
    mutationFunc(payload, {
      onSuccess: (res) => {
        if (res.data.success) {
          const responseId = res?.data?.data?.id;
          if (!id) {
            addIdToUrl(responseId);
          }

          if (id && id != responseId) {
            //id in params is not same as response id of the wheel, request by talha for cloning duplicate issue
            dispatch(setWheelId(responseId));
            window.history.replaceState(null, "", `/builder/${responseId}`);
          }

          dispatch(setIsDraft(true));
          callback && callback(res?.data?.data?.id, res?.data?.data);
          setShowUnSaved(false);
          setIsAutoSaving(false); // Stop animation after success
          if (isManualSave) {
            toast.success(successMessage); // Show toast only for manual saves
            dispatch(setIsSavingWheel(false));
          } else {
            setTimeout(() => {
              dispatch(setIsSavingWheel(false));
            }, 1000); // Delay stopping the saving wheel for auto-save
          }
          setIsAutoSaveError(false);
          prevIndexRef.current = currentIndex; // Update the previous index
        }
      },
      onError: (err) => {
        console.log({ err });
        setShowUnSaved(false);
        setIsAutoSaving(false); // Stop animation if error
        toast.error(err?.message); // Show error toast regardless
        setIsAutoSaveError(true);
        prevIndexRef.current = currentIndex; // Update the previous index

        if (!isManualSave) {
          setTimeout(() => {
            dispatch(setIsSavingWheel(false));
          }, 1000); // Delay stopping the saving wheel for auto-save errors
        } else {
          dispatch(setIsSavingWheel(false));
        }
      },
    });
  };

  console.log("hasUnsavedChanges", hasUnsavedChanges);

  // Update the handleSaveWheel function to mark changes as saved
  const handleSaveWheel = async (isManualSave = true, callback = () => {}) => {
    // Check if any segment exceeds the character limit
    let segmentWithExcessChars = null;
    for (const segment of wheelData) {
      try {
        const nodeMap =
          typeof segment.nodes === "string"
            ? JSON.parse(segment.nodes)
            : segment.nodes;
        const charCount = countTextCharacters(nodeMap, "ROOT");

        if (charCount > charLimitInASegment) {
          segmentWithExcessChars = segment;
          break;
        }
      } catch (error) {
        console.error(
          "Error counting characters for segment:",
          segment.id,
          error
        );
      }
    }

    if (segmentWithExcessChars) {
      toast.error(
        `Unable to save: Segment ${
          segmentWithExcessChars?.settings?.title || "Untitled"
        } has exceeded it's character limit`,
        {
          style: {
            backgroundColor: "#ffffff",
            color: "#000000",
            fontWeight: "500",
            border: "1px solid #e1e1e1",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          },
          toastId: "segment-char-limit-error",
          autoClose: 5000,
          position: "top-center",
        }
      );
      setIsAutoSaving(false);
      dispatch(setIsSavingWheel(false));
      return;
    }

    const mutationFunction = wheelIdInRedux
      ? updateWheel.mutate
      : createWheel.mutate;
    const successMessage = wheelIdInRedux
      ? "Wheel updated successfully"
      : "Wheel created successfully";

    let payload = generatePayload(
      wheelInformation?.history[wheelInformation?.currentIndex] || {},
      wheelWallpaperSettings
    );
    payload = wheelIdInRedux
      ? { ...payload, id: Number(wheelIdInRedux) }
      : { ...payload };

    if (!isManualSave) {
      setIsAutoSaving(true); // Start animation for auto-save
    }

    handleMutation(
      mutationFunction,
      successMessage,
      payload,
      isManualSave,
      async (id, response) => {
        // Mark changes as saved after successful save
        dispatch(markChangesSaved());

        if (response) {
          const updatedSegments = wheelData.map((segment) => {
            const matchingResponseSegment =
              response?.wheel_segments?.length > 0
                ? response?.wheel_segments?.find(
                    (respSegment) => respSegment.position === segment.position
                  )
                : null;

            return {
              ...segment,
              id: matchingResponseSegment?.id || segment.id, // Use response ID if available
              is_modified: false,
              initialNode: segment.nodes,
            };
          });

          dispatch(setWheelSegments(updatedSegments));
        }

        // Extract media URLs and send to API
        let mediaUrls = extractMediaUrlsOnly(segments);

        // Add wheel center media URL if it's an image
        if (
          payload.wheel_center_media?.type === "image" &&
          payload.wheel_center_media?.url
        ) {
          mediaUrls.push(payload.wheel_center_media.url);
        }

        if (
          payload?.wallpaper_settings?.current_bg === 2 &&
          payload?.wallpaper_settings?.bg_wallpaper
        ) {
          mediaUrls.push(payload?.wallpaper_settings?.bg_wallpaper);
        }
        if (mediaUrls.length > 0) {
          try {
            await sendWheelMedia(Number(wheelIdInRedux), mediaUrls);
          } catch (error) {
            console.error("Error sending media URLs:", error);
            // Continue with callback even if media update fails
          }
        }

        if (callback) callback(id);
      }
    );
  };

  const handleChangeSegmentRotationBox = () => {
    dispatch(setWheelRotateBoxVisibility(!rotateBoxVisibility));
  };

  const prevIndexRef = useRef(wheelInformation?.currentIndex); // Store the previous index at the top level
  useEffect(() => {
    if (!id) return; // Auto-save only for edit mode

    const interval = setInterval(() => {
      const currentIndex = wheelInformation?.currentIndex;

      // Check if the index has changed
      if (prevIndexRef.current !== currentIndex) {
        // Check if any segment exceeds limit before auto-saving
        let hasExcessChars = false;
        for (const segment of wheelData) {
          try {
            const nodeMap =
              typeof segment.nodes === "string"
                ? JSON.parse(segment.nodes)
                : segment.nodes;
            const charCount = countTextCharacters(nodeMap, "ROOT");

            if (charCount > charLimitInASegment) {
              hasExcessChars = true;
              break;
            }
          } catch (error) {
            console.error("Error checking segment chars for auto-save:", error);
          }
        }

        if (!hasExcessChars) {
          handleSaveWheel(false); // Trigger auto-save only if within limits
          prevIndexRef.current = currentIndex; // Update the previous index
        }
      }
    }, 30000); // Save every 30 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [id, wheelInformation, wheelWallpaperSettings, wheelData]);

  const [undoRedoTrigger, setUndoRedoTrigger] = useState(0);

  const onClickPortrait = () => {
    dispatch(handleMenuChange({ num: 1 }));
    dispatch(setWheelSettingsTab("1"));
  };

  useEffect(() => {
    if (!id) {
      handleSaveWheel(false);
    }
  }, [id]); // Make sure the effect runs whenever 'id' changes

  const currentIndex = wheelInformation?.currentIndex;
  useEffect(() => {
    if (prevIndexRef.current !== currentIndex) {
      setShowUnSaved(true); // Set `showUnSaved` to true if `currentIndex` changes
    }
  }, [currentIndex]);

  const [showBroadcastModal, setshowBroadcastModal] = useState(false);
  const toggleBroadcastModal = () => {
    setshowBroadcastModal(!showBroadcastModal);
  };

  const {
    mutate: sendBroadCast,
    isLoading,
    isSuccess,
    isError,
    data,
    error,
  } = useBroadcastChanges();

  const onSendBroadcastPress = () => {
    sendBroadCast(wheelIdInRedux, {
      onSuccess: () => {
        setshowBroadcastModal(false);
        setshowUpdateCloneModal(false);
        dispatch(setIsDraft(false));
        toast.success("Clone Synchronization Successful!");
        // Check if onLeave is a function before calling it
        if (typeof onLeave === "function") {
          onLeave();
        }
      },
    });
  };

  React.useEffect(() => {
    if (isError) {
      toast.error(`Error occurred: ${error?.message || "Unknown error"}`);
    }
  }, [isError, error]);

  const setLeaveModalOpen = (val) => {
    setModalOpen(val);
  };

  const isLive = useSelector(getWheelIsLiveValue);
  const isDraft = useSelector(getWheelIsDraftValue);

  // Update the handleLogoClick function to use the hasUnsavedChanges state
  const handleLogoClick = () => {
    if (isLive && isDraft) {
      setOnLeave(() => () => nav(`/gallery/${getLoggedInUser().id}`));
      setshowUpdateCloneModal(true);
      return;
    }

    if (hasUnsavedChanges) {
      setOnLeave(() => () => nav(`/gallery/${getLoggedInUser().id}`));
      setModalOpen(true);
    } else {
      getLoggedInUser()
        ? nav(`/gallery/${getLoggedInUser().id}`)
        : nav("/login");
    }
  };

  const onSaveAndExitPress = () => {
    handleSaveWheel(true, () => onLeave());
  };

  // Function to extract colors from wheel segments
  const extractColors = (segments) => segments?.map((segment) => segment.color);

  const [isScreenshotModalOpen, setIsScreenshotModalOpen] = useState(false);
  const [screenshotImage, takeScreenshot] = useScreenshot();

  const [wheelHtmlForScreenshot, setWheelHtmlForScreenshot] = useState("");

  const handleScreenshot = async () => {
    try {
      console.log("Taking wheel screenshot 1");
      setIsScreenshotModalOpen(true);

      // Wait for modal to render
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Take screenshot of the modal content
      const modalContent = document.querySelector(".modal-content");
      if (!modalContent) {
        throw new Error("Modal content not found");
      }

      const screenshot = await takeScreenshot(modalContent);
      console.log("Screenshot taken");

      // Create an image element to load the screenshot
      const img = new Image();
      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
        img.src = screenshot;
      });

      // Create a canvas for cropping
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Calculate crop dimensions (remove 27% from left/right, 18% from top/bottom)
      const cropX = img.width * 0.27;
      const cropY = img.height * 0.18;
      const cropWidth = img.width * 0.46;
      const cropHeight = img.height * 0.64;

      // Set canvas dimensions to cropped size
      canvas.width = cropWidth;
      canvas.height = cropHeight;

      // Draw the cropped portion of the image
      ctx.drawImage(
        img,
        cropX,
        cropY, // Source x, y
        cropWidth,
        cropHeight, // Source width, height
        0,
        0, // Destination x, y
        cropWidth,
        cropHeight // Destination width, height
      );

      // Convert canvas to blob
      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/png")
      );
      if (!blob) {
        throw new Error("Failed to create blob from cropped screenshot");
      }

      // Create a File object from the blob
      const file = new File([blob], "wheel-screenshot.png", {
        type: "image/png",
      });

      // Get the upload path for the wheel
      const wheelUploadPath = getWheelUploadPath({
        user_id: getLoggedInUser().id,
        wheel_id: wheelIdInRedux,
      });

      // Upload the file
      const result = await handleFileUpload(file, wheelUploadPath);
      dispatch(setWheelPreview(result?.location));
      // Close the modal after successful upload
      setIsScreenshotModalOpen(false);
    } catch (error) {
      console.error("Error capturing wheel screenshot:", error);
      setIsScreenshotModalOpen(false);
    }
  };

  const prevValues = useRef({
    wheelSegmentsLength: null,
    wheelSegmentsColors: [],
    wheelCenterMedia: null,
    wheelWallpaperSettings: null,
  });

  useEffect(() => {
    // Safely get the current and previous wheel data
    const currentWheel =
      wheelInformation?.history?.[wheelInformation?.currentIndex];
    if (!currentWheel) return; // Return early if there's no currentWheel data

    const wheelSegments = currentWheel?.wheel_segments;
    const wheelCenterMedia = currentWheel?.wheel_center_media;

    const prev = {
      wheelSegmentsLength:
        wheelInformation?.history?.[wheelInformation?.currentIndex - 1]
          ?.wheel_segments?.length,
      wheelSegmentsColors: extractColors(
        wheelInformation?.history?.[wheelInformation?.currentIndex - 1]
          ?.wheel_segments
      ),
      wheelCenterMedia: prevValues.current.wheelCenterMedia,
      wheelWallpaperSettings: prevValues.current.wheelWallpaperSettings,
    };

    const current = {
      wheelSegmentsLength: wheelSegments?.length,
      wheelSegmentsColors: extractColors(wheelSegments),
      wheelCenterMedia,
      wheelWallpaperSettings,
    };

    // Perform deep comparison using lodash or stringify if needed
    const segmentsColorChanged = !isEqual(
      prev.wheelSegmentsColors,
      current.wheelSegmentsColors
    );
    const otherValuesChanged =
      prev.wheelSegmentsLength !== current.wheelSegmentsLength ||
      prev.wheelCenterMedia !== current.wheelCenterMedia ||
      prev.wheelWallpaperSettings !== current.wheelWallpaperSettings;

    console.log(
      "Segment colors changed:",
      segmentsColorChanged,
      "Prev:",
      JSON.stringify(prev.wheelSegmentsColors),
      "Current:",
      JSON.stringify(current.wheelSegmentsColors)
    );

    if (
      wheelInformation?.currentIndex > 1 &&
      (segmentsColorChanged || otherValuesChanged)
    ) {
      // Trigger backend screenshot logic if there are changes
      dispatch(setTakeScreenshot(true));
      handleScreenshot();
      // Update the previous values
      prevValues.current = current;
    }
  }, [
    wheelInformation?.history,
    wheelWallpaperSettings,
    wheelInformation?.currentIndex,
  ]);

  const handleAddSegmentAfterAllLocked = () => {
    dispatch(handleMenuChange({ num: 1 })); // Open design tab
    dispatch(setDesignTabTarget("segments"));
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave?";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  const [base64Wallpaper, setBase64Wallpaper] = useState(null);
  const [centerImageBase64, setCenterImageBase64] = useState(null);
  useEffect(() => {
    const convertWallpaperToBase64 = async () => {
      if (bgWallpaper && bgWallpaper?.startsWith("http")) {
        try {
          const base64 = await fetchImageAsBase64(bgWallpaper);
          setBase64Wallpaper(base64);
        } catch (error) {
          console.error("Error converting wallpaper to base64:", error);
          setBase64Wallpaper(bgWallpaper);
        }
      } else {
        setBase64Wallpaper(bgWallpaper);
      }
    };

    convertWallpaperToBase64();
  }, [bgWallpaper]);

  useEffect(() => {
    const convertCenterImage = async () => {
      const centerUrl =
        wheelInformation?.history[wheelInformation?.currentIndex]
          ?.wheel_center_media?.url;
      let urlToConvert = centerUrl;
      if (!centerUrl) {
        urlToConvert = DefaultIyugaLogo;
      }
      if (urlToConvert && !urlToConvert.startsWith("data:image")) {
        try {
          const base64 = await fetchImageAsBase64(urlToConvert);
          setCenterImageBase64(base64);
        } catch (error) {
          setCenterImageBase64(urlToConvert); // fallback to original if conversion fails
        }
      } else {
        setCenterImageBase64(urlToConvert);
      }
    };
    convertCenterImage();
  }, [
    wheelInformation?.history[wheelInformation?.currentIndex]
      ?.wheel_center_media?.url,
  ]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      // Just dispatch close modal action
      // We don't need to prevent default here as we want the navigation to proceed
      dispatch(closeModal());
    };

    const handlePopState = () => {
      dispatch(closeModal());
    };

    // Add event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    // Clean up
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [dispatch]);

  // Check if any segment exceeds the character limit for UI feedback
  const hasCharLimitExceeded = wheelData.some((segment) => {
    try {
      const nodeMap =
        typeof segment.nodes === "string"
          ? JSON.parse(segment.nodes)
          : segment.nodes;
      const charCount = countTextCharacters(nodeMap, "ROOT");
      return charCount > charLimitInASegment;
    } catch (error) {
      return false;
    }
  });

  return (
    <>
      <Editor onNodesChange={handleNodesChange}>
        {/* <button onClick={handleScreenshot}>Take Wheel Screenshot</button> */}
        <WheelLayout
          handleSaveWheel={handleSaveWheel}
          setModalOpen={setLeaveModalOpen}
          setOnLeave={setOnLeave}
          onClickBeta={() => setWaitListModalVisible(true)}
          isAutoSaving={isAutoSaving}
          setIsAutoSaving={setIsAutoSaving}
          isAutoSaveError={isAutoSaveError}
          unsavedChanges={prevIndexRef.current !== currentIndex && showUnSaved}
          onBroadCastPress={toggleBroadcastModal}
          handleLogoClick={handleLogoClick}
          isEditScreen={true}
          hasCharLimitExceeded={hasCharLimitExceeded}
        >
          <BroadcastModal
            // prefixIcon={null}
            title="Synchronize Wheel Update!"
            modalText="Update all Synced Clones of this Wheel to the current version?"
            cancelButtonVisible={true}
            handleClose={toggleBroadcastModal}
            isOpen={showBroadcastModal}
            buttonText="Synchronize"
            onSubmit={onSendBroadcastPress}
            buttonLoading={isLoading}
          ></BroadcastModal>
          {/* <div>
            <button onClick={handleUndo}>Undo</button>
            <button onClick={handleRedo}>Redo</button>
          </div> */}
          {/* <UndoRedoComponent /> */}
          <Styled.MainDiv isEmptyWheel={isEmptyWheel}>
            <Styled.FlexMainDiv>
              <animated.div
                style={{
                  ...firstDivStyles,
                  height: "92vh",
                  position: "relative",
                  zIndex: 0,
                  overflow: "hidden",
                }}
              >
                {(currentBg === 2 || currentBg === 3) && bgWallpaper !== "" && (
                  <Styled.WheelWallpaperImage
                    currentBg={currentBg}
                    bgWallpaper={bgWallpaper}
                    wallpaperTransparency={wallpaperTransparency}
                  />
                )}
                {currentBg === 0 && (
                  <Styled.WheelWallpaperColor
                    color={segmentBgColor}
                    wallpaperTransparency={wallpaperTransparency}
                  />
                )}

                {loading ? (
                  <Loader />
                ) : (
                  <Styled.LeftSection>
                    <Grid
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                        marginLeft: !!selectedMenu ? "0" : "min(6vw, 60px)",
                        transition: "margin-left 0.3s ease",
                        padding: "0 20px",
                      }}
                    >
                      <WheelComponent
                        width="min(35vw, 500px)"
                        chartData={clonedWheelData}
                        setChartData={handleSetChartData}
                        showLabels={showLabels}
                        resize={false}
                        config={{
                          isNotDraggable: false,
                          segmentHighlighting: false,
                          // segmentLableOpacity: 1,
                        }}
                        userData={{
                          id: uuidv4(),
                          url:
                            wheelInformation?.history[
                              wheelInformation?.currentIndex
                            ]?.wheel_center_media?.url ||
                            ASSETS.userPlaceholder,
                        }}
                        onClickPortrait={onClickPortrait}
                      />

                      <SegmentActions
                        value={showLabels}
                        handleSwitch={handleSwitch}
                        handleSegmentButton={addSegment}
                        handleRotation={handleRotation}
                        selectedArc={selectedArc}
                        isSideMenuActive={isSideMenuActive}
                        isOpen={rotateBoxVisibility}
                        handleClick={handleChangeSegmentRotationBox}
                        isShowLeftOrRight={
                          wheelData?.length !== 0 || !isEmptyWheel
                        }
                        wheelData={wheelData}
                      />
                    </Grid>
                    {selectedArc ? (
                      <Grid item key={undoRedoTrigger}>
                        <SegmentView
                          selectedArc={selectedArc}
                          handleChange={handleChange}
                          handleMenuChange={(val) =>
                            dispatch(
                              handleMenuChange({ num: val, selectedArc })
                            )
                          }
                          onClose={onSegmentClose}
                          isBuilder={true}
                        />
                      </Grid>
                    ) : null}
                  </Styled.LeftSection>
                )}
              </animated.div>
              <animated.div
                style={{
                  ...secondDivStyles,
                  height: "92vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                  backgroundColor: "white",
                  flexShrink: 0,
                }}
              >
                {componentMap.map(({ isVisible, Component, props }, index) => (
                  <div
                    key={index}
                    style={{ display: isVisible ? "block" : "none" }} // Maintain mounting
                  >
                    {isVisible ? <Component {...props} /> : null}
                  </div>
                ))}
              </animated.div>
            </Styled.FlexMainDiv>
          </Styled.MainDiv>
          <DeleteModal />
          <MoveBlockModal wheelData={wheelData} />
        </WheelLayout>
      </Editor>

      <WaitlistFormModal
        open={waitListModalVisible}
        onClose={() => setWaitListModalVisible(false)}
      />

      <SaveChangesModal
        isOpen={modalOpen}
        onClose={handleCloseModal}
        onLeave={onLeave}
        onSave={() => {
          handleSaveWheel(true, () => onLeave());
        }}
        title={"Save Changes"}
        subtitle={
          "You have some unsaved changes. Are you sure you want to proceed without saving?"
        }
      />

      <UpdateLiveClones
        // prefixIcon={null}

        title="Update Sync Clones?"
        modalText="You have not synchronized the changes you've made to the Sync Clones of this Wheel. What would you like to do?"
        cancelButtonVisible={true}
        prefixIcon={
          <SyncProblemIcon style={{ color: "#E87033", marginRight: 5 }} />
        }
        handleClose={() => setshowUpdateCloneModal(false)}
        isOpen={showUpdateCloneModal}
        buttonText="Synchronize"
        repeatButtonText={"Save & Exit"}
        onBroadCastPress={onSendBroadcastPress}
        onSaveExitPress={onSaveAndExitPress}
        onExitPress={onLeave}
        buttonLoading={isLoading}
      ></UpdateLiveClones>

      <GallerySettings
        open={gallerySettingsOpen}
        onClose={() => {
          setGallerySettingsOpen(false);
          setOpenLibraryInBusinessBox(false);
        }}
        openDefault={!isEmpty(bboxData)}
        hideTabs
        title="Business Box"
        isWheelBusinessBox
        openLibrarySection={openLibraryInBusinessBox}
      />

      <ConfirmationModal
        isOpen={confirmationModalOpen}
        handleClose={() => setConfirmationModalOpen(false)}
        onConfirm={() => {
          handleBusinessBoxEditorOpen();
        }}
        title="Edit Alert"
        message={
          "Editing this Business Box will update it wherever it's used. Are you sure you wish to proceed?"
        }
      />

      <ConfirmationModal
        isOpen={lockWarningModalOpen}
        handleClose={() => setLockWarningModalOpen(false)}
        onConfirm={handleAddSegmentAfterAllLocked}
        title="Can't Add a Segment"
        message="All segments on this wheel are size-locked, so there's no space for a new one. To add a segment, unlock one or more existing segments."
        confirmText="Proceed"
      />

      {selectedType === "images" && isPreviewOpen && (
        <PreviewCarousel
          imageArray={
            segments?.filter((e) => e?.title === selectedSegment)[0]?.items
              ?.images
          }
          selectedImage={selectedItem}
        />
      )}

      <ScreenshotModal
        isOpen={isScreenshotModalOpen}
        onClose={() => setIsScreenshotModalOpen(false)}
        segmentBgColor={segmentBgColor}
        currentBg={currentBg}
        base64Wallpaper={base64Wallpaper}
        wallpaperTransparency={wallpaperTransparency}
        chartData={clonedWheelData}
        userData={{
          id: uuidv4(),
          url: centerImageBase64,
          isBase64: true,
        }}
        wheelId={wheelIdInRedux}
        userId={getLoggedInUser().id}
      />
    </>
  );
}
